import React, { useState } from 'react';
import { useRouter } from 'next/router';
import { FaShieldHalved, FaMagnifyingGlass, FaCar, FaCircleExclamation } from 'react-icons/fa6';
import { FaCheckCircle } from 'react-icons/fa';

const PLATE_REGEX = /^[A-Z]{3}[0-9][A-Z0-9][0-9]{2}$/;

export default function BlogCta({ compact = false }) {
  const router = useRouter();
  const [plate, setPlate] = useState('');
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const clean = e.target.value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase().slice(0, 7);
    setPlate(clean);
    if (error) {
      setError('');
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    const cleanPlate = plate.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

    if (!cleanPlate) {
      setError('Por favor, informe a placa do veículo.');
      return;
    }

    if (!PLATE_REGEX.test(cleanPlate)) {
      setError('Placa inválida. Digite no formato ABC1234 ou BRA2E19.');
      return;
    }

    setError('');
    router.push(`/consulta/rapida/completa?placa=${cleanPlate}`);
  };

  if (compact) {
    return (
      <div
        className="rounded-4 p-4 my-4 text-white position-relative overflow-hidden shadow-sm"
        style={{ background: 'linear-gradient(135deg, #0F172A 0%, #1E3A8A 100%)' }}
      >
        <div className="d-flex align-items-center gap-2 mb-2">
          <span className="badge bg-warning text-dark fw-bold rounded-pill px-3 py-1">
            <FaShieldHalved className="me-1" /> Dica de Segurança
          </span>
        </div>
        <h4 className="fw-bold mb-2">Vai comprar ou negociar um seminovo?</h4>
        <p className="text-light small mb-3 opacity-90">
          Não corra o risco de comprar veículo com leilão, sinistro, débitos ou restrições judiciais.
        </p>
        <form onSubmit={handleSearch} className="w-100" noValidate>
          <div className="d-flex flex-column flex-sm-row gap-2 align-items-stretch">
            <div className="flex-grow-1 position-relative">
              <input
                type="text"
                className={`form-control rounded-pill px-3 py-2 text-uppercase fw-bold text-center text-sm-start w-100 ${
                  error ? 'is-invalid border-warning shadow-none' : 'border-0'
                }`}
                placeholder="Placa (ex: BRA2E19)"
                value={plate}
                maxLength={7}
                onChange={handleChange}
                autoComplete="off"
                aria-label="Placa do veículo"
              />
            </div>
            <button
              type="submit"
              className="btn btn-warning rounded-pill px-4 py-2 fw-bold text-dark shadow-sm text-nowrap d-inline-flex align-items-center justify-content-center gap-2"
            >
              <FaMagnifyingGlass size={14} />
              <span>Consultar Placa</span>
            </button>
          </div>
          {error && (
            <div className="text-warning small mt-2 fw-semibold d-flex align-items-center gap-1">
              <FaCircleExclamation size={13} />
              <span>{error}</span>
            </div>
          )}
        </form>
      </div>
    );
  }

  return (
    <div
      className="rounded-5 p-4 p-md-5 my-5 text-white position-relative overflow-hidden shadow-lg"
      style={{
        background: 'linear-gradient(135deg, #0F172A 0%, #1D4ED8 100%)',
      }}
    >
      <div className="row align-items-center position-relative" style={{ zIndex: 2 }}>
        <div className="col-lg-8 text-center text-lg-start mb-4 mb-lg-0">
          <span className="badge bg-white text-primary rounded-pill px-3 py-2 text-uppercase fw-bold mb-3 shadow-sm d-inline-flex align-items-center gap-2">
            <FaShieldHalved /> Segurança Veicular AboutCar
          </span>
          <h3 className="display-6 fw-bold mb-3 text-white">
            Evite dores de cabeça e golpes na compra do seu próximo carro
          </h3>
          <p className="lead text-light opacity-90 fs-6 mb-4" style={{ maxWidth: '600px' }}>
            Com a consulta completa da AboutCar você descobre histórico de leilão, sinistro, roubo e furto, débitos, multas e restrições em segundos.
          </p>
          <div className="d-flex flex-wrap justify-content-center justify-content-lg-start gap-3 small text-white opacity-90">
            <span className="d-inline-flex align-items-center gap-1">
              <FaCheckCircle className="text-warning" /> Dados 100% Oficiais
            </span>
            <span className="d-inline-flex align-items-center gap-1">
              <FaCheckCircle className="text-warning" /> Laudo Imediato
            </span>
            <span className="d-inline-flex align-items-center gap-1">
              <FaCheckCircle className="text-warning" /> Sem mensalidade
            </span>
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="bg-white p-4 rounded-4 shadow text-dark">
            <div className="fw-bold mb-2 fs-5">Consulte agora</div>
            <p className="text-muted small mb-3">Informe a placa para ver o histórico</p>
            <form onSubmit={handleSearch} className="d-flex flex-column gap-2" noValidate>
              <div className="input-group">
                <span className="input-group-text bg-light border-end-0 rounded-start-pill ps-3">
                  <FaCar className="text-muted" />
                </span>
                <input
                  type="text"
                  className={`form-control border-start-0 rounded-end-pill py-2 text-uppercase fw-bold ${
                    error ? 'is-invalid border-danger' : ''
                  }`}
                  placeholder="Placa (ex: BRA2E19)"
                  value={plate}
                  maxLength={7}
                  onChange={handleChange}
                  autoComplete="off"
                  aria-label="Placa do veículo"
                />
              </div>
              {error && (
                <div className="text-danger small fw-semibold text-start ps-2 d-flex align-items-center gap-1">
                  <FaCircleExclamation size={12} />
                  <span>{error}</span>
                </div>
              )}
              <button
                type="submit"
                className="btn btn-primary rounded-pill py-2 fw-bold shadow-sm d-flex align-items-center justify-content-center gap-2 mt-1"
              >
                <FaMagnifyingGlass size={14} />
                Puxar Histórico
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
